import React, { memo } from "react";
import styles from "../ParentResult.module.css";

function SearchResult({ locations = [], isLoading }) {
  if (isLoading) {
    return (
      <div className={styles.searchResultContainer}>
        <div className={styles.searchResultTitel}>
        </div>

        <div className={styles.searchResult}>
          <p>Suche läuft...</p>
        </div>
      </div>
    );
  }

  if (!locations.length) {
    return (
      <div className={styles.searchResultContainer}>
        <div className={styles.searchResultTitel}>
        </div>

        {/* <div className={styles.searchResult}>
          <p style={{ color: "red" }}>
            Keine Ergebnisse gefunden
          </p>
        </div> */}
      </div>
    );
  }

  return (
    <div className={styles.searchResultContainer}>
      <div className={styles.searchResultTitel}>
      </div>

      {/* <div className={styles.searchResult}>
        {locations.map((item) => (
          <div
            key={item.id || item.lexm_id}
            className={styles.resultItem}
          >
            <p>{item.name || "No name"}</p>
          </div>
        ))}
      </div> */}
    </div>
  );
}

export default memo(SearchResult);